import { createSelector } from '@reduxjs/toolkit'
import { populateAgentDetailsForReview } from './collectorDetailsSelector'
import { currentAgentApplicationSelector } from "./collectorApplicationSelector"
import { populateCriminalHistoryListDataForReview } from './criminalDetailsSelector'

import {
    populateLicenceHistoryListQuestionForReview,
    populateLicenceHistoryListDataForReview,
    populateLicenceSuspensionQuestionForReview,
    populateLicenceSuspensionDataForReview
} from './licenceDetailsSelector'

const collectorApplicationReviewSelector = createSelector(
    [state => state.components,
    currentAgentApplicationSelector],
    (components,currentApplicationSelector) => {
        const {businessLicenceData} = currentApplicationSelector
        const {
            criminalHistoryData,
            licenceHistoryDetails,
            licenceSuspendedData
        } = businessLicenceData

        return Object.assign({},
            components.collectorApplicationReview,
            {
                reviewDetails : {
                    applicantDetails :  populateAgentDetailsForReview(businessLicenceData),
                    criminalHistoryListData : populateCriminalHistoryListDataForReview(criminalHistoryData),
                    LicenceHistoryListQuestion : populateLicenceHistoryListQuestionForReview(licenceHistoryDetails),
                    LicenceHistoryListData : populateLicenceHistoryListDataForReview(licenceHistoryDetails),
                    licenceSuspendedQuestion : populateLicenceSuspensionQuestionForReview(licenceSuspendedData, true),
                    licenceSuspendedData : populateLicenceSuspensionDataForReview(licenceSuspendedData),
                }
            })
    }
)

export const collectorApplicationReviewSelect = state => ({
    collectorApplicationReview: collectorApplicationReviewSelector(state)
})
